<footer class="site-footer">
  <div class="footer-newsletter-wrap page-section-rail">
    <div class="footer-newsletter-card">
      <div class="footer-newsletter-card__bg" aria-hidden="true">
        <img class="footer-newsletter-card__pattern" src="/assets/brand/figma/footer-newsletter-pattern.png" alt=""
          loading="lazy" decoding="async" fetchpriority="low" />
      </div>
      <img class="footer-newsletter-card__plane" src="/assets/brand/figma/footer-newsletter-plane.png" alt=""
        aria-hidden="true" loading="lazy" decoding="async" fetchpriority="low" />
      <img class="footer-newsletter-card__vector" src="/assets/brand/figma/footer-newsletter-vector.svg" alt=""
        aria-hidden="true" loading="lazy" decoding="async" fetchpriority="low" />
      <h3 class="footer-newsletter-card__title">{{ 'footer.newsletter_title' | t }}</h3>
      <div class="footer-newsletter-card__form">
        <img class="footer-newsletter-card__mail" src="/assets/icons/figma/footer-mail.svg" alt="" width="16"
          height="16" aria-hidden="true" />
        <input type="email" [placeholder]="'footer.email_placeholder' | t" />
        <button type="button">{{ 'footer.submit' | t }}</button>
      </div>
    </div>
  </div>

  <div class="footer-main">
    <div class="footer-content page-section-rail">
      <div class="footer-brand">
        <a routerLink="/" class="footer-brand__logo-link" [attr.aria-label]="'header.home_aria' | t">
          <img class="footer-brand__logo" src="/assets/brand/figma/nav-logo.png" width="128" height="56"
            alt="ZeroTech Stores" loading="lazy" decoding="async" fetchpriority="low" />
        </a>
        <p class="footer-tagline">{{ 'footer.tagline' | t }}</p>
        <div class="social-links" [attr.aria-label]="'footer.social_links' | t">
          <a *ngFor="let social of socialLinks"
            [href]="social.isCallChooser ? null : social.href"
            [attr.role]="social.isCallChooser ? 'button' : null"
            target="_blank" rel="noopener noreferrer"
            [attr.aria-label]="social.labelKey | t"
            (click)="onSocialClick($event, social)">
            <img [src]="social.iconUrl" [alt]="social.labelKey | t" loading="lazy" decoding="async" fetchpriority="low" />
          </a>
        </div>
      </div>

      <div class="footer-column footer-column--contact">
        <h4>{{ 'footer.col_talk_to_us' | t }}</h4>
        <p class="footer-contact-lead">{{ 'footer.link_call_us' | t }}</p>
        <div class="footer-contact-numbers">
          <a class="footer-contact-number" [href]="mobileTelHref" dir="ltr">
            <span class="footer-contact-number__label">{{ 'contact.call_mobile' | t }}</span>
            {{ mobileDisplay }}
          </a>
          <a class="footer-contact-number" [href]="hotlineTelHref" dir="ltr">
            <span class="footer-contact-number__label">{{ 'contact.call_hotline' | t }}</span>
            {{ hotlineDisplay }}
          </a>
        </div>

        <p class="footer-contact-address">{{ 'footer.link_address' | t }}</p>
      </div>

      <div class="footer-column">
        <h4>{{ 'footer.col_information' | t }}</h4>
        <a class="" href="mailto:info@zerotechsystems.org">info&#64;zerotechsystems.org</a>
        <a routerLink="/support">{{ 'footer.link_contact_us' | t }}</a>
        <a routerLink="/return-and-exchange-policy">{{ 'footer.link_return_policy' | t }}</a>
      </div>

      <div class="footer-column">
        <h4>{{ 'footer.col_account' | t }}</h4>
        <a routerLink="/account">{{ 'footer.link_track_orders' | t }}</a>
        <a routerLink="/wishlist">{{ 'footer.link_wishlist' | t }}</a>
        <a routerLink="/account">{{ 'footer.link_my_account' | t }}</a>
        <a routerLink="/account">{{ 'footer.link_order_history' | t }}</a>
      </div>
    </div>
  </div>

  <div class="footer-bottom">
    <div class="footer-bottom__top page-section-rail">
      <a routerLink="/" class="footer-bottom__logo-link" [attr.aria-label]="'header.home' | t">
        <img class="footer-bottom__logo" src="/assets/brand/figma/footer-logo-egypt.png" alt="ZeroTech Stores"
          width="287" height="101" loading="lazy" decoding="async" fetchpriority="low" />
      </a>
      <!-- <div class="footer-lang" role="group" [attr.aria-label]="'footer.language' | t">
        <button type="button" class="footer-lang__btn" [class.footer-lang__btn--pill]="(language$ | async) === 'en'" (click)="setLanguage('ar')">
          {{ 'footer.lang_ar' | t }}
        </button>
        <button type="button" class="footer-lang__btn" [class.footer-lang__btn--pill]="(language$ | async) === 'ar'" (click)="setLanguage('en')">
          {{ 'footer.lang_en' | t }}
        </button>
      </div> -->
    </div>
    <div class="footer-bottom__rule page-section-rail" aria-hidden="true"></div>
    <p class="footer-copy">{{ 'footer.copy' | t }}</p>
  </div>
</footer>

<div class="call-chooser" *ngIf="callChooserOpen" role="dialog" [attr.aria-label]="'contact.call_chooser_title' | t">
  <button type="button" class="call-chooser__backdrop" (click)="closeCallChooser()" [attr.aria-label]="'common.close' | t"></button>
  <div class="call-chooser__sheet">
    <p class="call-chooser__title">{{ 'contact.call_chooser_title' | t }}</p>
    <a class="call-chooser__option" [href]="mobileTelHref" (click)="closeCallChooser()">
      <span class="call-chooser__option-label">{{ 'contact.call_mobile' | t }}</span>
      <span class="call-chooser__option-value" dir="ltr">{{ mobileDisplay }}</span>
    </a>
    <a class="call-chooser__option" [href]="hotlineTelHref" (click)="closeCallChooser()">
      <span class="call-chooser__option-label">{{ 'contact.call_hotline' | t }}</span>
      <span class="call-chooser__option-value" dir="ltr">{{ hotlineDisplay }}</span>
    </a>
    <button type="button" class="call-chooser__cancel" (click)="closeCallChooser()">{{ 'common.cancel' | t }}</button>
  </div>
</div>
